























import { computed, defineComponent, onMounted, ref, toRef, watch } from "@vue/composition-api";
import BaseIcon from "@/components/Base/BaseIcon";
import BaseButton from "@/components/BaseButton";
import PlayButton from "@/components/PlayButton";

export default defineComponent({
  name: "BaseStreamVideo",
  components: { BaseIcon, PlayButton, BaseButton },
  props: {
    autoplay: { type: Boolean },
    loop: { type: Boolean },
    stream: { type: MediaStream, default: null },
    mirrorVideo: { type: Boolean, default: false },
    controls: { type: Boolean, default: false },
  },
  setup(props) {
    const player = ref<HTMLVideoElement>();
    const isPaused = ref<boolean>(false);
    const isMuted = ref<boolean>(false);

    const showOverlay = computed(() => isMuted.value || isPaused.value);

    const autoPlayRetryVideo = async () => {
      if (!player.value) return;
      isPaused.value = false;
      isMuted.value = false;
      await player.value?.play().catch(async () => {
        isMuted.value = true;
        player.value && (player.value.muted = true);
        await player.value?.play().catch(() => {
          setTimeout(() => {
            if (player.value?.paused) isPaused.value = true;
          }, 500);
        });
      });
      isPaused.value = player.value.paused;
    };

    if (props.stream) {
      watch(
        toRef(props, "stream"),
        async () => {
          if (!player.value) return;
          if (props.stream) player.value.srcObject = props.stream;
          if (props.autoplay) {
            await autoPlayRetryVideo();
          } else {
            await player.value.play();
          }
        },
        { immediate: true }
      );
    }

    watch(toRef(props, "autoplay"), async () => {
      if (!player.value) return;
      if (props.autoplay) {
        await autoPlayRetryVideo();
      } else {
        await player.value.pause();
        player.value.currentTime = 0;
      }
    });

    onMounted(() => {
      if (props.autoplay && player.value && (player.value as any).videoTracks) {
        (player.value as any).videoTracks.onaddtrack = () => {
          if (player.value?.paused) autoPlayRetryVideo();
        };
      }
    });

    return { player, isMuted, isPaused, showOverlay, autoPlayRetryVideo };
  },
});
